<template>
  <div>
    <b-tabs align="left" pills v-model="tabIndex">
      <b-tab title="Account Receivable Report" :title-link-class="linkClass(tabField.account.index)" v-if="$can('read', 'account_report')">
        <account-receivable-report v-if="tabIndex == tabField.account.index" />
      </b-tab>
      <b-tab title="Received Statement Report" :title-link-class="linkClass(tabField.statement.index)" v-if="$can('read', 'statement_report')"
        ><received-statement-report v-if="tabIndex == tabField.statement.index"
      /></b-tab>
      <b-tab title="Bookkeeping Revenue Report" :title-link-class="linkClass(tabField.revenue.index)" v-if="$can('read', 'revenue_report')"
        ><bookkeeping-revenue-report v-if="tabIndex == tabField.revenue.index"
      /></b-tab>
      <b-tab
        title="Additional Revenue Bookkeeping  Report"
        :title-link-class="linkClass(tabField.additional.index)"
        v-if="$can('read', 'additional_revenue_report')"
        ><add-rev-bookkeeping-revenue-report v-if="tabIndex == tabField.additional.index"
      /></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab, BCard, BButton, VBTooltip } from "bootstrap-vue";

import moment from "moment";
import { formatCurrency } from "@/utils/helpers";
import qs from "qs";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import AccountReceivableReport from "./AccountReceivableReport.vue";
import ReceivedStatementReport from "./ReceivedStatementReport.vue";
import BookkeepingRevenueReport from "./BookkeepingRevenueReport.vue";
import AddRevBookkeepingRevenueReport from "./AddRevBookkeepingRevenueReport.vue";
export default {
  data() {
    return {
      BASE_URL: process.env.VUE_APP_BASEURL,
      moment: moment,
      tabIndex: 0,
      tabField: {
        account: {
          index: 0,
          perms: this.$can('read', 'account_report')
        },
        statement: {
          index: 1,
          perms: this.$can('read', 'statement_report')
        },
        revenue: {
          index: 2,
          perms: this.$can('read', 'revenue_report')
        },
        additional: {
          index: 3,
          perms: this.$can('read', 'additional_revenue_report')
        }
      }
    };
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BTabs,
    BTab,
    BCard,
    FeatherIcon,
    BButton,
    VBTooltip,
    AccountReceivableReport,
    ReceivedStatementReport,
    BookkeepingRevenueReport,
    AddRevBookkeepingRevenueReport,
  },
  beforeMount() {
    this.setTabIndex();
  },
  methods: {
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-outline-primary", "text-dark-blue"];
      }
    },
    setTabIndex() {
      let fields = Object.values(this.tabField);
      let indexCount = 0;
      for(const field of fields){
        if(field.perms){
          field.index = indexCount;
          indexCount++;
        }else{
          field.index = null;
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 2px solid #dddddd;
  text-align: left;
  padding: 8px;
  font-weight: 550;
}
tr:hover {
  background-color: yellow;
}

::v-deep .text-dark-blue {
  color: #003366 !important;
}
</style>
